module.exports = __webpack_public_path__ + "img/routes_mobile.21b0e00c.png";